import React, {FC} from 'react';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {SynopsisCellDetail, SynopsisSummary} from './synopsisCellDetail';
import {SynopsisMessageDetail, SynopsisMessageDetailTypesEnum} from './synopsisHelpers';
import {InquiryStatusIcon} from './synopsisInquiryIcon';
import {SynopsisQuickAction, SynopsisQuickActionsEnum} from './synopsisQuickAction';
import {SynopsisRelatedKnowledge} from './synopsisRelatedKnowledge';
import {SynopsisSimilarInquiries} from './synopsisSimilarInquiries';
import {useSynopsisViewerContext} from './synopsisViewerContext';

interface SynopsisMessageDetailPreviewProps {
  detail: SynopsisMessageDetail;
  isFollowUp?: boolean;
  panelId: ViewerPanelId;
}

export const SynopsisMessageDetailPreview: FC<SynopsisMessageDetailPreviewProps> = ({
  detail,
  isFollowUp,
  panelId,
}) => {
  const {summary, timestamp, activityId} = detail;
  const [inquiry, similarInquiries, relatedKnowledgeReferences] =
    detail.type === SynopsisMessageDetailTypesEnum.INQUIRY
      ? [detail.inquiry, detail.similarInquiries, detail.relatedKnowledgeReferences]
      : [];

  const {onJumpToItem, onFeedbackAction, setCopyText} = useSynopsisViewerContext();

  return (
    <>
      <SynopsisCellDetail
        statusIcon={inquiry ? <InquiryStatusIcon inquiry={inquiry} /> : undefined}
        timestamp={timestamp}
        actions={
          <SynopsisQuickAction
            actionId={SynopsisQuickActionsEnum.FEEDBACK}
            onClick={() =>
              onFeedbackAction({
                activity_id: activityId,
                type: detail.type,
                origin: 'message',
                node_id: detail.id,
              })
            }
          />
        }
        isFollowUp={isFollowUp}
        onClick={() => onJumpToItem({activityId, itemType: detail.type})}
        onMouseEnter={() => setCopyText(`${summary.verb} ${summary.remainder}`)}
        onMouseLeave={() => setCopyText('')}
      >
        <SynopsisSummary summary={summary} />
      </SynopsisCellDetail>
      {similarInquiries && (
        <SynopsisSimilarInquiries similarInquiries={similarInquiries} detail={detail} panelId={panelId} />
      )}
      {relatedKnowledgeReferences && (
        <SynopsisRelatedKnowledge
          relatedKnowledgeReferences={relatedKnowledgeReferences}
          detail={detail}
          panelId={panelId}
        />
      )}
    </>
  );
};
